import { render } from "./ForgotComponent.vue?vue&type=template&id=7ab48621&scoped=true"
import script from "./ForgotComponent.vue?vue&type=script&lang=js"
export * from "./ForgotComponent.vue?vue&type=script&lang=js"

import "./ForgotComponent.vue?vue&type=style&index=0&id=7ab48621&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab48621"]])

export default __exports__